/* eslint-disable @typescript-eslint/no-explicit-any */
export const splitParams = (
	params: object,
	predicate: ([key, value]: [string, any]) => boolean,
) =>
	Object.entries(params).reduce(
		(result, [key, value]) => {
			result[predicate([key, value]) ? 0 : 1][key] = value;
			return result;
		},
		[{}, {}] as [Record<string, any>, Record<string, any>],
	);
